<template>
	<div id="double_validation_container">
		<div
			id="iev_modal_cvp"
			class="iev_modal_cvp_div"
			:class="{ active: is_Active }"
		>
			<div
				id="iev_modal_cvp_bg"
				class="iev_modal_cvp-background"
				@click="is_Active = false"
			></div>
			<div class="iev_modal_cvp-content">
				<div class="iev_box double_verify_form">
					<div class="iev_header">Verification Required</div>
					<div class="iev_body">
						<h3>We need additional information</h3>
						<p>
							Please complete the verification process to submit your votes.
						</p>
					</div>
					<div id="iev_validation_ui_container">
						<div
							class="iev_section"
							:class="{ active: step == 1 }"
							ref="step_1"
						>
							<ol class="stepper">
								<li class="stepper__item active">
									<h3 class="stepper__title">Send code</h3>
									<p class="stepper__desc">
										Enter your
										{{
											verification_method === 'phone'
												? 'mobile phone number'
												: 'email address'
										}}
										<br />
										and click "Send Code"
									</p>
								</li>
								<li class="stepper__item">
									<h3 class="stepper__title">Verify code</h3>
									<p class="stepper__desc">
										Enter the six digit code that you <br />
										received
										{{
											verification_method === 'phone' ? 'via SMS' : 'via email'
										}}
									</p>
								</li>
							</ol>
							<!-- Phone Verification Form -->
							<div
								v-if="verification_method === 'phone'"
								id="phone_verification_form"
							>
								<div class="iev_modal_cvp_input_container">
									<label>Enter your mobile phone number below</label>
									<div class="iev_form_inline">
										<input
											v-model="phone_number"
											type="text"
											placeholder="###-###-####"
										/>
										<button
											v-if="
												!smsOptInEnabled || (smsOptInEnabled && smsOptInCheck)
											"
											@click="sendCode"
										>
											Send Code
										</button>
										<div v-else class="background-filter-container">
											<div class="disabled-background-filter"></div>
											<button disabled>Send Code</button>
										</div>
									</div>
									<p>
										<label v-if="smsOptInEnabled" class="container"
											>By checking this box you are agreeing to receive text
											messages to the above phone number. Your phone number will
											not be used for any marketing or non-essential
											communications.
											<input
												type="checkbox"
												@click="smsOptInCheck = !smsOptInCheck"
												:checked="smsOptInCheck"
											/>
											<span class="checkmark"></span>
										</label>
									</p>
									<p :class="{ danger: phone_error !== '' }">
										{{ phone_error }}
									</p>
									<p>
										Your mobile number will NOT be used for any marketing
										purposes.
									</p>
									<p>Please note: standard texting rates will apply</p>
								</div>
							</div>

							<!-- Email Verification Form -->
							<div v-else id="email_verification_form">
								<div class="iev_modal_cvp_input_container">
									<label>Enter your email address below</label>
									<div
										class="name_fields"
										style="margin-top: 1em; display: flex; gap: 1em"
									>
										<input
											v-model="first_name"
											type="text"
											placeholder="First Name"
											style="flex: 1"
										/>
										<input
											v-model="last_name"
											type="text"
											placeholder="Last Name"
											style="flex: 1"
										/>
									</div>
									<div class="iev_form_inline">
										<input
											v-model="email"
											type="email"
											placeholder="your@email.com"
										/>
										<button @click="sendCode">Send Code</button>
									</div>
									<div
										v-if="verification_sender_email"
										class="sender-email-notice"
										style="margin-top: 0.5em; font-size: 1em"
									>
										<p>
											<strong class="iev_emphasize">Please Note -</strong>
											The code will be sent from:
											<strong>{{ verification_sender_email }}</strong>
										</p>
									</div>
									<p :class="{ danger: email_error !== '' }">
										{{ email_error }}
									</p>
									<p>
										Your email will NOT be added to any email list or shared
										with any third party organization.
									</p>
								</div>
							</div>
							<div class="sending" v-if="sending"><h1>Sending ...</h1></div>
						</div>
						<div
							class="iev_section"
							:class="{ active: step == 2 }"
							ref="step_2"
						>
							<ol class="stepper">
								<li class="stepper__item active">
									<h3 class="stepper__title">Send code</h3>
									<p class="stepper__desc">
										Enter your
										{{
											verification_method === 'phone'
												? 'mobile phone number'
												: 'email address'
										}}
										<br />
										and click "Send Code"
									</p>
								</li>
								<li class="stepper__item active">
									<h3 class="stepper__title">Verify code</h3>
									<p class="stepper__desc">
										Enter the six digit code that you
										<br />
										received
										{{
											verification_method === 'phone' ? 'via SMS' : 'via email'
										}}
									</p>
								</li>
							</ol>
							<div id="code_verification_form">
								<div class="iev_modal_cvp_input_container">
									<label>Enter the six digit number below</label>
									<div class="iev_form_inline">
										<input
											v-model="temp_code"
											type="text"
											placeholder="######"
										/>
										<button @click="verifyCode">Verify Code</button>
									</div>
									<p :class="{ danger: temp_code_error !== '' }">
										{{ temp_code_error }}
									</p>
									<p>
										Didn't receive the code or having trouble with the code that
										was sent?
										<a @click="step = 1" style="cursor: pointer"
											>Try again here!</a
										>
									</p>
								</div>
							</div>
							<div class="sending" v-if="verifying"><h1>Verifying ...</h1></div>
							<div class="sending" v-if="verify_success">
								<h1>Verification complete!</h1>
								<h2>... resubmitting your votes now!</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
			<button
				class="modal-close is-large"
				aria-label="close"
				@click="is_Active = false"
			></button>
		</div>
	</div>
</template>
<script>
import { get, url, post } from '../api';
export default {
	props: ['active', 'verification_code', 'request_code', 'campaignID'],
	data: () => ({
		step: 1,
		loading: false,
		sending: false,
		verifying: false,
		verify_success: false,
		phone_error: '',
		phone_number: '',
		temp_code_error: '',
		temp_code: null,
		is_Active: false,
		smsOptInEnabled: false,
		smsOptInCheck: false,
		verification_method: 'phone',
		email: '',
		first_name: '',
		last_name: '',
		email_error: '',
		verification_sender_email: '',
	}),
	watch: {
		active: function (val) {
			this.is_Active = val;
		},
	},
	methods: {
		matchHeight() {
			let step_1_height = this.$refs.step_1.clientHeight;
			let step_2_height = this.$refs.step_2.clientHeight;
			let new_height = Math.max(step_1_height, step_2_height);

			this.$refs.step_1.style.height = new_height + 'px';
			this.$refs.step_2.style.height = new_height + 'px';
			this.$refs.sending_notice.style.height = new_height + 'px';
		},
		sendCode() {
			const vm = this;
			vm.phone_error = '';
			vm.email_error = '';

			if (vm.verification_method === 'email') {
				// Email validation
				if (!vm.email || !vm.email.includes('@')) {
					vm.email_error = 'Please enter a valid email address';
					return;
				}

				vm.sending = true;
				post('doubleverify', {
					email: vm.email,
					first_name: vm.first_name,
					last_name: vm.last_name,
					validation_code: vm.verification_code,
					request_code: vm.request_code,
					campaign_hash: vm.campaignID,
				}).then(
					(data) => {
						vm.sending = false;
						console.log(data);

						if (data.double_verify_code_sent_success == 'true') {
							vm.step = 2;
						} else if (data.double_verify_complete_success == 'true') {
							this.$emit(
								'updatevalidationvalues',
								data.updated_validation.code,
								data.updated_validation.request_code,
							);
							vm.verify_success = true;
							setTimeout(function () {
								vm.$emit('submit');
							}, 1000);
						}
					},
					(error) => {
						vm.sending = false;
						console.log(error.response.data);
						if (
							error.response.data.error &&
							error.response.data.message != ''
						) {
							if (error.response.data.message.email) {
								vm.email_error = error.response.data.message.email[0];
							} else if (error.response.data.message) {
								vm.email_error = error.response.data.message;
							} else {
								vm.email_error =
									'There was an error with your email verification. Please try again.';
							}
						} else {
							vm.email_error =
								'There was an error with your submission. Please try again.';
						}
					},
				);
			} else {
				// Phone validation and API call
				let phone = vm.phone_number.replace(/\D/g, '');
				if (phone.length < 10 || phone.length > 14) {
					vm.phone_error = 'Please enter a valid number';
					return;
				}

				vm.sending = true;
				post('doubleverify', {
					phone_number: phone,
					validation_code: vm.verification_code,
					request_code: vm.request_code,
					campaign_hash: vm.campaignID,
					sms_opt_in_enabled: vm.smsOptInEnabled,
				}).then(
					(data) => {
						vm.sending = false;
						console.log(data);

						if (data.double_verify_code_sent_success == 'true') {
							vm.step = 2;
						} else if (data.double_verify_complete_success == 'true') {
							this.$emit(
								'updatevalidationvalues',
								data.updated_validation.code,
								data.updated_validation.request_code,
							);
							vm.verify_success = true;
							setTimeout(function () {
								vm.$emit('submit');
							}, 1000);
						}
					},
					(error) => {
						vm.sending = false;
						console.log(error.response.data);
						if (
							error.response.data.error &&
							error.response.data.message != ''
						) {
							if (error.response.data.message.phone_number) {
								vm.phone_error = error.response.data.message.phone_number[0];
							} else if (error.response.data.message) {
								vm.phone_error = error.response.data.message;
							} else {
								vm.phone_error =
									'There was an error with your verification code. Please try again.';
							}
						} else {
							vm.phone_error =
								'There was an error with your submission. Please try again.';
						}
					},
				);
			}
		},
		verifyCode() {
			const vm = this;
			vm.temp_code_error = '';
			if (vm.temp_code == null || vm.temp_code.length != 6) {
				vm.temp_code_error = 'Please enter your six digit code.';
			}

			if (vm.temp_code_error == '') {
				console.log("Let's Go!");
				vm.verifying = true;
				console.log(vm.verification_code);
				console.log(vm.request_code);
				post('doubleverifycomplete', {
					temp_code: vm.temp_code,
					validation_code: vm.verification_code,
					request_code: vm.request_code,
				}).then(
					(data) => {
						vm.verifying = false;
						console.log(data);

						if (data.double_verify_complete_success == 'true') {
							//Update validation codes

							console.log(localStorage.getItem('iever_code_hash'));
							console.log(localStorage.getItem('iever_sesh_verify_code'));

							this.$emit(
								'updatevalidationvalues',
								data.updated_validation.code,
								data.updated_validation.request_code,
							);

							// vm.validation_code = data.updated_validation.code;
							// vm.request_code = data.updated_validation.request_code;

							console.log('ON child:');

							console.log(data.updated_validation.code);
							console.log(vm.verification_code);
							console.log(data.updated_validation.request_code);
							console.log(vm.request_code);

							console.log(localStorage.getItem('iever_code_hash'));
							console.log(localStorage.getItem('iever_sesh_verify_code'));

							vm.verify_success = true;
							vm.$emit('submit');
						} else {
							vm.temp_code_error = data.message + ' Please try again.';
						}
					},
					(error) => {
						vm.verifying = false;
						vm.verify_success = false;
						console.log(error.response.data);
						if (
							error.response.data.error &&
							error.response.data.message != ''
						) {
							//Not used anymore
							console.log('Post in else after message');
							vm.temp_code_error =
								'There was an error with your verification code. Please try again!';
						} else {
							vm.temp_code_error =
								'There was an error with your submission. Please try again.';
						}
					},
				);
			}
		},
	},
	mounted() {
		const vm = this;
		// debugger;

		if (sms_opt_in_enabled && sms_opt_in_enabled == '1') {
			this.smsOptInEnabled = true;
		}

		// Set verification method from global variable
		if (typeof verification_method !== 'undefined') {
			this.verification_method = verification_method;
		}

		// Set verification sender email from global variable
		if (typeof verification_sender_email !== 'undefined') {
			this.verification_sender_email = verification_sender_email;
		}

		let app_container_style = document.querySelector('.app-wrapper');
		app_container_style = app_container_style.getAttribute('style');

		let old_parent = document.getElementById('double_validation_container');
		old_parent.childNodes[0].setAttribute('style', app_container_style);
		document.body.appendChild(old_parent.childNodes[0]);

		// vm.matchHeight();

		// setTimeout(function () {
		//     vm.$emit('returnToStart');
		// }, 4000);
	},
};
</script>
<style scoped>
.iev_modal_cvp_input_container {
	margin: 1em auto;
	max-width: 100%;
	width: 460px;
}

.iev_form_inline {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
}

.iev_modal_cvp_input_container label {
	font-size: 1.5em;
	font-weight: 300;
}
.iev_modal_cvp_input_container input {
	font-size: 1.5em;
	font-weight: 300;
	width: 300px;
	padding: 0.5em;
	border-radius: 8px;
	margin: 0.25em 0;
	border: solid 1px rgba(0, 0, 0, 0.3);
}
.iev_modal_cvp_input_container input.danger {
	border: solid 1px rgba(255, 0, 0, 0.3);
}
.iev_modal_cvp_input_container button {
	font-size: 1.5em;
	font-weight: 300;
	padding: 0.5em 1em;
	width: auto;
	border: none;
	white-space: nowrap;
	background-color: var(--secondary-color);
	color: rgba(0, 0, 0, 0.8);
	text-transform: capitalize;
	border-radius: 8px;
	margin: 0.25em 0;
}
.iev_modal_cvp_input_container p {
	font-size: 1em;
	font-weight: 300;
}

.iev_modal_cvp_input_container p.danger {
	color: red;
}

.iev_modal_cvp_input_container p.notice {
	color: orange;
}

.iev_modal_cvp_input_container p.success {
	color: green;
}

.iev_box {
	background-color: #fff;
	border-radius: 6px;
	box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
		0 0 0 1px rgba(10, 10, 10, 0.02);
	color: #4a4a4a;
	display: block;
	padding: 0rem;
	padding-bottom: 20px;
}

.iev_box .iev_header {
	border-radius: 6px 6px 0px 0px;
	box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
		0 0 0 1px rgba(10, 10, 10, 0.02);
	padding: 1em 1.5em;
	font-size: 1.25em;
	font-weight: 300;
	background-color: var(--secondary-color);
	color: #000;
}

.iev_box .iev_body {
	padding: 1.5em;
}

.iev_box .iev_section {
	position: relative;
	display: none;
	background-color: white;
	padding: 1.5em;
}

.iev_box .iev_section.active {
	display: block;
}

.iev_box .iev_section .sending {
	position: absolute;
	top: 0px;
	left: 0px;
	z-index: 999999999999999;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.95);
}

.iev_box .iev_section .sending h1 {
	font-size: 3em;
	color: rgba(0, 0, 0, 0.75);
}

.iev_section_header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}

.iev_section_header h2 {
	flex-grow: 1;
}

.double_verify_form h1,
.double_verify_form h2,
.double_verify_form h3,
.double_verify_form p {
	margin: 0;
	padding: 0;
	margin-bottom: 1em;
}

.double_verify_form h1 {
	font-size: 1.5em;
	font-weight: 300;
}

.double_verify_form h3 {
	font-size: 20px;
}

#iev_modal_cvp {
	display: none;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	overflow: hidden;
	position: fixed;
	z-index: 1000000;
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
}

#iev_modal_cvp.active {
	display: flex;
}

#iev_modal_cvp .iev_modal_cvp-background {
	background-color: rgba(10, 10, 10, 0.86);
	bottom: 0;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	-webkit-backdrop-filter: blur(5px);
	backdrop-filter: blur(5px);
}

#iev_modal_cvp .iev_modal_cvp-content {
	overflow: auto;
	position: relative;
	margin: 0 auto;
	max-height: calc(100vh - 40px);
	max-width: calc(100vw - 40px);
}

#iev_modal_cvp .is-large.modal-close {
	height: 64px;
	max-height: 64px;
	max-width: 64px;
	min-height: 64px;
	min-width: 64px;
	width: 64px;
}

#iev_modal_cvp .modal-close {
	background: 0 0;
	height: 80px;
	position: fixed;
	right: 20px;
	top: 20px;
	width: 80px;
	cursor: pointer;
	pointer-events: auto;
	font-size: 0;
	border: none;
	border-radius: 9999px;
	cursor: pointer;
	pointer-events: auto;
	display: inline-block;
}

#iev_modal_cvp .modal-close,
#iev_modal_cvp .modal-close {
	background-color: rgba(10, 10, 10, 0.3);
}

#iev_modal_cvp .modal-close:focus,
#iev_modal_cvp .modal-close:hover {
	background-color: rgba(10, 10, 10, 0.6);
}

#iev_modal_cvp .modal-close::before {
	height: 2px;
	width: 50%;
}

#iev_modal_cvp .modal-close::after {
	height: 50%;
	width: 2px;
}

#iev_modal_cvp .modal-close::after,
#iev_modal_cvp .modal-close::before {
	background-color: #fff;
	content: '';
	display: block;
	left: 50%;
	position: absolute;
	top: 50%;
	transform: translateX(-50%) translateY(-50%) rotate(45deg);
	transform-origin: center center;
}

@media only screen and (min-width: 768px) {
	#iev_modal_cvp .iev_modal_cvp-content {
		width: 720px;
	}
}

.background-filter-container {
	position: relative;
}
.disabled-background-filter {
	background-color: rgba(0, 0, 0, 0.3);
	position: absolute;
	top: 0.4em;
	left: 0;
	z-index: 99;
	width: 100%;
	height: calc(100% - 0.71em);
	border-radius: 8px;
}

/* Customize the label */
.container {
	display: block;
	position: relative;
	padding-left: 30px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 1em !important;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	padding-top: 0;
	padding-right: 0;
	padding-bottom: 0;
}

/* Hide the browser's default checkbox */
.container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkmark {
	position: absolute;
	top: 5px;
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e9ecef;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
	background-color: #ccc;
}

/* When the checkbox is checked, */
.container input:checked ~ .checkmark {
	background-color: var(--secondary-color);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
	content: '';
	position: absolute;
	display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
	display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
	left: 6px;
	top: 1px;
	width: 8px;
	height: 15px;
	border: solid #fff;
	border-width: 0 3px 3px 0;
	-webkit-transform: rotate(45deg);
	-ms-transform: rotate(45deg);
	transform: rotate(45deg);
}

.stepper {
	display: flex;
}

.stepper__item {
	display: flex;
	flex-direction: column;
	flex: 1;
	text-align: center;

	&:before {
		--size: 3rem;
		content: '';
		display: block;
		width: clamp(1.5rem, 5vw, 3rem);
		height: clamp(1.5rem, 5vw, 3rem);
		border-radius: 50%;
		background-color: lightgrey;
		margin: 0 auto 1rem;
	}

	&.active::before {
		background-color: var(--secondary-color) !important;
	}

	&:after {
		background-color: var(--secondary-color) !important;
	}

	&:not(:last-child) {
		&:after {
			content: '';
			position: relative;
			top: calc(clamp(1.5rem, 5vw, 3rem) / 2);
			width: calc(
				100% - clamp(1.5rem, 5vw, 3rem) - calc(clamp(0.25rem, 2vw, 0.5rem) * 2)
			);
			left: calc(
				50% + calc(clamp(1.5rem, 5vw, 3rem) / 2 + clamp(0.25rem, 2vw, 0.5rem))
			);
			height: 2px;
			background-color: #e0e0e0;
			order: -1;
		}
	}
}

.stepper__title {
	font-weight: bold;
	font-size: clamp(1rem, 4vw, 1.25rem);
	margin-bottom: 0.2rem !important;
}

.stepper__desc {
	color: grey;
	font-size: clamp(0.85rem, 2vw, 1rem);
	padding-left: clamp(0.25rem, 2vw, 0.5rem);
	padding-right: clamp(0.25rem, 2vw, 0.5rem);
}
</style>
